// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"aed9b8d4","579":"1d0020c8","949":"9f1c21f3","965":"5d522768"}[chunkId] + ".chunk.js";
};